// @ts-nocheck
import React, {useContext, useReducer} from 'react'
import {DateRangeInput} from "react-datepicker/packages/styled";
import styled from "styled-components";
import {CartContext} from "../../contexts/cart/cart.context";
import moment from "moment";

const initialState = {
    startDate: null,
    endDate: null,
    focusedInput: null,
};

function reducer(state, action) {
    switch (action.type) {
        case 'focusChange':
            return {...state, focusedInput: action.payload};
        case 'dateChange':
            return action.payload;
        default:
            throw new Error()
    }
}

export const PaddedHeader = styled.h3`
    margin-bottom: 18px
`;
const Container = styled.div`
    margin-bottom: 30px
`;


const StyledDateTimePicker: React.FC<StyledDateTimePickerProps> = (props) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const {cart: {orderEndTime, orderStartTime,}, setOrderStartTime, setOrderEndTime} = useContext(CartContext);
    return (
        <Container>
            <DateRangeInput
                showClose={false}
                numberOfMonths={props.numberOfMonths || 2}
                showSelectedDates={false}
                verticalInputs={true}
                vertical={false}
                displayFormat={"dd MMMM, yyyy"}
                onDatesChange={data => {
                    setOrderStartTime(moment(data.startDate).toISOString());
                    data.endDate && setOrderEndTime(moment(data.endDate).toISOString());
                    dispatch({type: 'dateChange', payload: data})
                }}
                onFocusChange={focusedInput => dispatch({type: 'focusChange', payload: focusedInput})}
                startDate={orderStartTime ? moment(orderStartTime).toDate() : null} // Date or null
                endDate={orderEndTime ? moment(orderEndTime).toDate() : null} // Date or null
                focusedInput={state.focusedInput} // START_DATE, END_DATE or null
                isDateBlocked={(date) => {
                    return moment(date).isSameOrBefore(moment())
                }}
                {...props}
            />
        </Container>
    )
};
export default StyledDateTimePicker;